module.exports = __webpack_public_path__ + "static/media/match_started.db406898.svg";